export default {
  about: 'About',
  requestQuote: 'Request a Quote',
  requestAlliance: 'Request an Alliance',
  editProfile: 'Edit my profile',
  completedProjects: 'Projects',
  noAchievements: 'No achievements',
  alliances: 'Alliances',
  noAlliances: 'No alliances found',
  profileNotFound: 'Profile not found',
  profileNotFoundSubtitle: 'This profile does not exist or is no longer available.',
  location: 'City',
  languages: 'Languages',
} as const;
